var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgHighlight = function SvgHighlight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 62,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.304 25.274c.783-5.358.815-10.866.807-16.205-.006-1.149-.926-2.098-2.042-2.036-1.127-.018-2.034.921-2.039 1.99.013 5.173 0 10.513-.76 15.622-.167 1.09.603 2.14 1.718 2.325 1.114.185 2.148-.606 2.316-1.696zM28.902 38.289c7.417-9.42 13.605-19.748 21.27-29.035.72-.832.597-2.13-.268-2.84s-2.156-.625-2.865.288c-7.69 9.29-13.903 19.622-21.345 29.044a2.1 2.1 0 00.352 2.912c.875.626 2.166.541 2.856-.37zM63.582 49.661l-14.488 2.611c-1.114.144-1.848 1.226-1.648 2.35.202 1.124 1.254 1.809 2.368 1.665l14.51-2.615a2.09 2.09 0 001.625-2.428c-.197-1.042-1.265-1.807-2.367-1.583z",
    fill: "#FF1462"
  })));
};
export default SvgHighlight;